import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import Checkmark from '../icons/checkmark.svg';

import Section from './Section';
import CtaLink from './ui/CtaLink';

const Display = (props) => {
  const {
    title,
    content,
    subtitle,
    listTitle,
    list = [],
    reverse = false,
    image,
    cta,
    children,
    className,
    wide = false
  } = props;
  return (
    <StyledSection wide={wide} className={className}>
      <Wrapper reverse={reverse}>
        <ContentWrapper>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
          <Title>{title}</Title>
          <Content>{content}</Content>
          <List>
            {listTitle && <ListTitle>{listTitle}</ListTitle>}
            {list.map((listItem) => (
              <ListItem key={listItem}>
                <ListBullet />
                <ListItemText>{listItem}</ListItemText>
              </ListItem>
            ))}
          </List>
          {cta && (
            <CtaLink to={cta.to} color={cta.color}>
              {cta.label}
            </CtaLink>
          )}
          {children}
        </ContentWrapper>
        <ImageWrapper>
          <GatsbyImage
            image={image.childImageSharp.gatsbyImageData}
            alt={title}
          />
        </ImageWrapper>
      </Wrapper>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  margin-bottom: 200px;

  ${({ theme }) => `
    @media ${theme.mediumUp} {
      margin-bottom: 250px;
    }
  `}
`;

const Wrapper = styled.div`
  ${({ theme, reverse }) => `
  @media ${theme.xLargeUp} {
    display: flex;
    flex-direction: ${reverse ? 'row-reverse' : 'row'}};
    align-items: center;
    justify-content: space-between;
  }
  `}
`;

const ContentWrapper = styled.div`
  margin-bottom: 60px;
  ${({ theme }) => `
    @media ${theme.xLargeUp} {
      margin-bottom: 0px;
      width: 60%;
      max-width: 640px;
    }
  `}
`;

const Subtitle = styled.h3`
  color: var(--gray-dark);
  font-size: var(--font-size-lg);
  margin-bottom: 5px;
`;

const Title = styled.h2`
  color: var(--blue-dark);
  font-size: var(--heading-size-base);
  line-height: var(--line-height-base);
  margin-bottom: 15px;
  font-weight: var(--font-weight-bold);
`;

const Content = styled.p`
  font-size: var(--font-size-lg);
  margin-bottom: 30px;
`;

const ListTitle = styled.strong`
  font-weight: var(--font-weight-black);
  color: var(--black);
  margin-bottom: 20px;
  display: block;
`;

const List = styled.ul`
  margin-bottom: 38px;
`;

const ListItem = styled.li`
  margin-bottom: 15px;
  display: flex;
  align-items: start;

  &:last-of-type {
    margin-bottom: 0px;
  }
`;

const ListItemText = styled.span`
  display: inline-block;
  padding-left: 20px;
`;

const ListBullet = styled(Checkmark)`
  display: inline-block;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-top: 4px;
`;

const ImageWrapper = styled.div`
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      max-width: 700px;
      margin: auto;
    }
    @media ${theme.xLargeUp} {
      width: 75%;
      max-width: 900px;
      padding: 0 5%;
    }
`}
`;

export default Display;
